export default __webpack_public_path__ + "static/media/HankenGrotesk-Bold.a3c57b0d.ttf";